export const ADMIN = 'ADMIN'

export const ADMIN_MASTER = 'ADMIN_MASTER'

export const PRODUCTOR = 'PRODUTOR'

export const PRODUCTOR_MUSICAL = 'PRODUTOR_MUSICAL'

export const PRODUCTOR_CAST = 'PRODUTOR_ELENCO'

export const MANAGER = 'GESTOR'
